import { getWindow } from '../general';
import { IReturnLabel } from '../../models/returns';
import {
  IErrorReturnService,
  IPrintLabelError,
} from '../../models/returns/returns-common';

export const openNativeAppLabel = (htmlLabel: string) => {
  const base64Html = btoa(htmlLabel);
  getWindow()?.LIFE_CYCLE_EVENT_BUS?.trigger('NATIVE_APP.PRINT_BASE64', {
    base64HtmlData: base64Html,
  });
};

export const openNewWindow = (): Window | null => {
  const newWindow = window.open(
    '',
    '_blank',
    'top=0,left=0,height=750px,width=auto,scrollbars=yes,resizable=yes',
  );
  return newWindow;
};

export const createHtmlContent = (
  returnLabels: IReturnLabel[],
  orderId: string,
): string => {
  const base64decode = 'data:image/png;base64,';
  const conversionSrcArray = returnLabels.map((label) => {
    const graphicLabelImage =
      label?.labelGraphicImage || label?.LabelGraphicImage;
    return base64decode + graphicLabelImage;
  });
  return `
  <!DOCTYPE html PUBLIC>
  <html>
    <head>
      <title>Return Label | Order #${orderId}</title>
      <style>
      @page {
        size: landscape;
      }
      </style>
    </head>
    <body style='text-align:center'>
      <div id='imgDiv' style='display:block'>
        ${conversionSrcArray
          .map(
            (conversionSrc, index) =>
              `<img src='${conversionSrc}' alt='Label ${index + 1}' /><br />${
                index !== conversionSrcArray.length - 1
                  ? '<div style="page-break-after: always;"></div>'
                  : ''
              }`,
          )
          .join('')}
      </div>
      <script>
        const printLabel = () => {
          window.print();
        };

        // Print the labels after a delay to allow the images to load
        setTimeout(printLabel, 1000);
      </script>
    </body>
  </html>
`;
};

export const getErrorBySSRCode = (
  error: IErrorReturnService,
): IPrintLabelError => {
  switch (error.code) {
    case 'SSR_UPSPRNTLBL_ERR_1003':
      // Non UPS Tracking Number Error
      return {
        type: 'TEMPORARY',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1012':
      // Label Not Found Error
      return {
        type: 'TRYAGAIN',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1013':
      // Not Printable Error. Same case as Switched to Pickup
      return {
        type: 'SWITCHEDTOPICKUP',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1014':
      // Label Reuse Error
      return {
        type: 'USED',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1015':
      // Expired Label Error
      return {
        type: 'EXPIRED',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1016':
      // Invalid Label Error (switched from dropoff to pickup)
      return {
        type: 'SWITCHEDTOPICKUP',
        retryable: error.retryable,
      };
    case 'SSR_UPSPRNTLBL_ERR_1017':
      // Missing Tracking ID Error
      return {
        type: 'TEMPORARY',
        retryable: error.retryable,
      };
    default:
      // Unknown Error
      return {
        type: 'UNKNOWN',
        retryable: error.retryable,
      };
  }
};
